import { useEffect, useRef } from "react";
import { useIntersectionObserver } from "usehooks-ts";

const useInView = (callBack: () => void) => {
	const inViewRef = useRef<HTMLDivElement | null>(null);
	const entry = useIntersectionObserver(inViewRef, {});
	const isVisible = !!entry?.isIntersecting;

	useEffect(() => {
		if (isVisible) {
			callBack();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isVisible]);

	return inViewRef;
};

export { useInView };
